import script from "./ResRetrieve.vue?vue&type=script&setup=true&lang=js"
export * from "./ResRetrieve.vue?vue&type=script&setup=true&lang=js"

import "./ResRetrieve.vue?vue&type=style&index=0&id=f6e8cd8c&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6e8cd8c"]])

export default __exports__